import type { AnswerResult } from "@/types";

type GameState = "answering" | "revealed";

export function getOptionState(
  optionId: string,
  answerResult: AnswerResult | null,
  selected: string | null,
  gameState: GameState,
): "default" | "selected" | "correct" | "incorrect" {
  if (gameState === "answering") {
    return optionId === selected ? "selected" : "default";
  }
  if (!answerResult) return "default";
  if (optionId === answerResult.correctOptionId) return "correct";
  if (optionId === selected) return "incorrect";
  return "default";
}

export function getReviewOptionState(
  optionId: string,
  selectedOptionId: string,
  correctOptionId: string | null,
): "default" | "correct" | "incorrect" {
  if (correctOptionId && optionId === correctOptionId) return "correct";
  if (optionId === selectedOptionId) return "incorrect";
  return "default";
}
